/*
 * @Author: Dong
 * @Date: 2022-04-20 11:14:22
 * @LastEditors: luting
 * @LastEditTime: 2022-12-15 14:32:57
 */
import { UpdateQueueType } from '../types';
import { UPDATE_QUEUE, ADD_QUEUE, CLEAR_FILE_CONFIG } from 'root/store/constant';
import { uploadFileStatus } from './types';

const defaultStates: uploadFileStatus = {
  queueState: {
    queue: [],
  },
};

const uploadFile = (state = { ...defaultStates }, action: any) => {
  const { queue } = state.queueState;
  const { type, payload } = action;

  switch (type) {
    // 清空数据
    case CLEAR_FILE_CONFIG: {
      return {
        ...defaultStates,
      };
    }
    // 添加上传队列
    case ADD_QUEUE: {
      const newQueue = queue.concat(payload.queue);
      return {
        ...state,
        queueState: {
          queue: newQueue,
        },
      };
    }
    // 更新任务
    case UPDATE_QUEUE: {
      const { viewId, ...reset } = payload;
      const newQueue = queue.map((item: UpdateQueueType) => {
        let newItem = { ...item };
        // 挑选出正在上传的包
        if (item.viewId === viewId) {
          newItem = { ...newItem, ...reset };
        }
        return newItem;
      });

      return {
        ...state,
        queueState: {
          queue: newQueue,
        },
      };
    }
    // 删除队列
    case 'deleteQueue': {
      const { viewId } = payload;
      const newQueue = queue.filter((item) => item.viewId !== viewId);
      return {
        ...state,
        queueState: {
          queue: newQueue,
        },
      };
    }
    // 改变任务状态
    case 'changeStatus': {
      const { name, version, status } = payload;
      const newQueue = queue.map((item: UpdateQueueType) => {
        const newItem = { ...item };
        if (item.name === name && item.version === version) {
          newItem.status = status;
        }
        return newItem;
      });

      return {
        ...state,
        queueState: {
          queue: newQueue,
        },
      };
    }
    default:
      return state;
  }
};

export default uploadFile;
